const ENV = process.env.REACT_APP_ENV || 'LOCAL';

const environments = {
  LOCAL: {
    frontendUrl: 'http://localhost:3000',
    wordpressUrl: 'http://localhost:8888/Website/wordpress',
    graphqlEndpoint: 'http://localhost:8888/Website/wordpress/graphql',
    apiEndpoint: 'http://localhost:8888/Website/wordpress/wp-json'
  },
  STAGING: {
    frontendUrl: 'https://staging.belvoircastle.com',
    wordpressUrl: 'https://staging.belvoircastle.com/wp',
    graphqlEndpoint: 'https://staging.belvoircastle.com/wp/graphql',
    apiEndpoint: 'https://staging.belvoircastle.com/wp/wp-json'
  },
  LIVE: {
    frontendUrl: 'https://www.belvoircastle.com',
    wordpressUrl: 'https://www.belvoircastle.com/wp',
    graphqlEndpoint: 'https://www.belvoircastle.com/wp/graphql',
    apiEndpoint: 'https://www.belvoircastle.com/wp/wp-json'
  }
};

const config = environments[ENV];

if (!config) {
  throw new Error(`Invalid environment: ${ENV}`);
}

export default config; 